import { PortalManager } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

import { GLOBAL_AI_PORTAL_LAYER_Z_INDEX } from '../CustomDash/constants/panelWidths';

/**
 * Re-stamps every Chakra portal opened from this subtree (chart tooltips,
 * popovers, menus) to `GLOBAL_AI_PORTAL_LAYER_Z_INDEX` so it stacks above
 * the AI assistant drawer card.
 *
 * The app root's `ChakraProvider` sets `portalZIndex={40}` (main.tsx), which
 * wraps every default Chakra portal in a `z-index: 40` container — below the
 * drawer card (`GLOBAL_AI_OVERLAY_Z_INDEX` 1400) — so a Chakra tooltip opened
 * from a chart inside the drawer paints behind the drawer. `portalZIndex` is
 * itself just a root-level `PortalManager`, and Chakra portals resolve the
 * NEAREST manager, so mounting one here overrides the z-index for portals
 * opened from this subtree only; the rest of the app keeps the root value.
 */
export const GlobalAiPortalLayer = ({ children }: PropsWithChildren) => (
  <PortalManager zIndex={GLOBAL_AI_PORTAL_LAYER_Z_INDEX}>
    {children}
  </PortalManager>
);
